// src/pages/Details.js  —— 完整最終版
import React, { useState, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CircularProgress, IconButton, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { createOrder } from '../api';
import { PaymentContext } from '../contexts/PaymentContext';
import { AppContext } from '../contexts/AppContext';
import '../styles/Details.css';
 

function Details() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { setPaymentData } = useContext(PaymentContext);
  const { carParkInfo, currentLang, setCurrentLang } = useContext(AppContext);
   const notDateTime = localStorage.getItem('entryTimestamp');
  // ==== 語言選單 ====
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  
  const handleLangChange = (code) => {
    setCurrentLang(code);
    handleClose();
  };
  const getCurrentLangLabel = () => 
    currentLang === 'zh-tw' ? '繁中' : currentLang === 'zh-cn' ? '简中' : 'Eng';

  const otherLangs = [
    { code: 'zh-tw', label: '繁中' },
    { code: 'zh-cn', label: '简中' },
    { code: 'en', label: 'Eng' },
  ].filter(l => l.code !== currentLang);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [forceFree, setForceFree] = useState(false);

  // 翻譯
  const t = (key) => {
    const map = {
      'zh-tw': { title: '泊車詳情', carplate: '車牌號碼', entryTime: '入場時間', duration: '停泊時間',
                 freeParking: '免費泊車優惠', totalAmount: '總付款金額', back: '返回', payNow: '立即付款', noPhoto: '沒有相片',  entryTimestampExpired: '資料已過期，請搜尋車牌重新嘗試'},
      'zh-cn': { title: '停车详情', carplate: '车牌号码', entryTime: '进场时间', duration: '停车时长',
                 freeParking: '免费停车优惠', totalAmount: '总支付金额', back: '返回', payNow: '立即支付', noPhoto: '沒有相片',  entryTimestampExpired: '资料已过期，请搜索车牌重新尝试' },
      'en': { title: 'PARKING DETAILS', carplate: 'Licence Plate Number', entryTime: 'Entry Time', duration: 'Parking Duration',
                 freeParking: 'Free Parking', totalAmount: 'Total Amount', back: 'BACK', payNow: 'PAY NOW', noPhoto: 'No Photo',  entryTimestampExpired: 'Data expired, please search carplate and try again' },
    };
    return map[currentLang]?.[key] || map.en[key];
  };

  // 基本檢查
  if (!state?.Carplate || !state?.EntryTime || !carParkInfo?.guid) {
    navigate('/', { replace: true });
    return null;
  }

  // 計算免費時間顯示文字
  const formatFreeParking = () => {
    const mins = Number(state.RefundValue || 0);
    if (mins <= 0) return '---';

    const hours = mins / 60;
    if (currentLang === 'en') {
      return hours === 1 ? '1 hour' : `${hours} hours`;
    } else {
      return hours === 1 ? '1 小時' : `${hours} 小時`;
    }
  };

  // 是否真正免費（影響總金額同按鈕）
  const isFree = state.IsFree || (state.RefundValue > 0 && state.CarparkFee <= 0);
  const finalAmount = isFree ? 0 : state.CarparkFee;

  const formatDateTime = (d) => {
    if (!d) return '-';
    const date = new Date(d);
    return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')} ${String(date.getHours()).padStart(2,'0')}:${String(date.getMinutes()).padStart(2,'0')}`;
  };

  const formatDuration = (mins) => {
    if (!mins && mins !== 0) return '-';
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    if (currentLang === 'en') {
      return `${h ? h+' hrs' : ''}${h && m ? ' ' : ''}${m ? m+' mins' : ''}`.trim() || '0 mins';
    }
    return `${h ? h+' 小時' : ''}${h && m ? ' ' : ''}${m ? m+' 分鐘' : ''}`.trim() || '0 分鐘';
  };

  const formatFee = (fee) => `HK$${Number(fee ?? 0).toFixed(1)}`;

  const handlePayment = async () => {
    let paymentIsFree = isFree || forceFree;
    if (paymentIsFree) return;
    // const getEntryPaymentDate = localStorage.getItem('entryTimestamp');
    console.debug(`[DETAILS LOG] PAYMENT CLICKED: entryTimestamp from localStorage: ${notDateTime}`);
    const getNowTime = Date.now();
    if(getNowTime - notDateTime > 3 * 60 * 1000) { // 3分鐘
      setError(t('entryTimestampExpired'));
      console.debug(`[ENQUIRY LOG] CHECK VALIDATION FAILED: Entry timestamp is too old. Current: ${getNowTime}, Entry: ${notDateTime}`);
      setForceFree(true);
      return;
    }
    setLoading(true);
    try {
      const res = await createOrder(state.Carplate, state.CarparkFee, state.EntryTime, carParkInfo.guid);
      if (res.result === 0 && res.data?.invoice?.paymentLinkUrl) {
        setPaymentData({ carplate: state.Carplate, entrytime: state.EntryTime, fee: state.CarparkFee });
        window.location.href = res.data.invoice.paymentLinkUrl;
      }
    } catch (err) {
      setError('付款失敗，請重試');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="new-details-container">

      {/* Top Bar */}
      <div className="new-top-bar">
        <img src="/wilsonparking.jpg" alt="Wilson Parking" className="new-logo" />
        <div className="new-lang-selector">
          <IconButton onClick={handleClick} className="new-lang-btn">
            <LanguageIcon />
          </IconButton>
          <span className="new-lang-text">{getCurrentLangLabel()}</span>
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            {otherLangs.map(l => (
              <MenuItem key={l.code} onClick={() => handleLangChange(l.code)}>{l.label}</MenuItem>
            ))}
          </Menu>
        </div>
      </div>

      <div className="new-orange-title">{t('title')}</div>

      <div className="new-card">

        {/* Photo */}
        {state.LpnPhotoPath ? (
          <img src={`data:image/jpeg;base64,${state.LpnPhotoPath}`} alt="Plate" className="new-plate-img" />
        ) : (
          <div className="new-no-photo">{t('noPhoto')}</div>
        )}

        <div className="new-row">
          <span className="new-label">{t('carplate')}</span>
          <span className="new-value">{state.Carplate}</span>
        </div>

        <div className="new-row">
          <span className="new-label">{t('entryTime')}</span>
          <span className="new-value">{formatDateTime(state.EntryTime)}</span>
        </div>

        <div className="new-row">
          <span className="new-label">{t('duration')}</span>
          <span className="new-value">{formatDuration(state.DurationMinutes)}</span>
        </div>

        {/* 永久顯示 Free Parking 行 */}
        <div className="new-row new-free-row">
          <span className="new-label">{t('freeParking')}</span>
          <span className="new-value">{formatFreeParking()}</span>
        </div>

        {/* Total Amount */}
        <div className="new-total-row">
          <span className="new-total-label">{t('totalAmount')}</span>
          <span className="new-total-amount">{formatFee(finalAmount)}</span>
        </div>

        {/* Buttons */}
        <div className="new-buttons">
          <button className="new-btn-back" onClick={() => navigate('/')}>
            {t('back')}
          </button>
          <button
            className="new-btn-pay"
            onClick={handlePayment}
            disabled={loading || isFree || forceFree}
            style={{ background: (isFree || forceFree) ? '#a0aec0' : '#ffb800' }}
          >
            {loading ? <CircularProgress size={26} color="inherit" /> : t('payNow')}
          </button>
        </div>

        {error && <div className="new-error">{error}</div>}
      </div>
    </div>
  );
}

export default Details;